import { useQuery } from '@tanstack/react-query';
import moment from 'moment';

import { TimeSlotDict, tokenRequests } from '../api/api';
import cacheQueryKeys from '../resources/queryCacheKeys';
import { useToastController } from '../toast';
import { statusCodesMapper } from '../utils/exception';

export type ServicePayload = { uuid: string; quantity: number };
export type PricingFormsPayload = {
  uuid: string;
};

type Props = {
  token: string;
  dateFrom: Date;
  dateTo: Date;
  services?: ServicePayload[];
  pricingForms?: PricingFormsPayload[];
  onSuccess?: (data?: TimeSlotDict) => void;
};

const formatDay = (day: Date) => moment(day).format('YYYY-MM-DD');

export const useTimeSlotsDict = ({ token, dateFrom, dateTo, onSuccess, pricingForms, services }: Props) => {
  const { showToast } = useToastController();

  return useQuery(
    [cacheQueryKeys.OnlineBookingTimeSlots],
    async () => {
      const response = await tokenRequests.fetchTimeSlotsV3(
        formatDay(dateFrom),
        formatDay(dateTo),
        services,
        pricingForms,
        token
      );

      return statusCodesMapper(response, {
        unhandled: () => {
          showToast('Something went wrong, please try again.');
          throw new Error();
        },
        success: (data) => {
          return Object.fromEntries(data.map((day) => [day.date, day.time_slots]));
        },
      });
    },
    {
      staleTime: 0,
      onSuccess,
    }
  );
};
